export default "__VITE_ASSET__CKfpTeep__"